import React, {useReducer} from 'react';
import { useToasts } from 'react-toast-notifications'
import {  errorToast} from '../../utils/ToastUtil'

import VacationContext from './VacationContext'
import VacationReducer from './VacationReducer'

import {callVacationByUser} from '../../http_services/vacation';


import { 
    LOADING,
    GET_ACCOUNT_VACATION
} from "../../types";

const VacationState = (props) => {
    const { addToast } = useToasts();

    const initialState = {
        loading: false,
        vacation: null
    }

    const [state, dispatch] = useReducer(VacationReducer, initialState);   

    const getVacationByUser = async () => {
        try{
            loading()
                const resp = await callVacationByUser();
                dispatch({
                    type: GET_ACCOUNT_VACATION,
                    payload: resp
                  });
            loading()
        }catch(err){
            loading()
            addToast('Error al un error al tratar de obtener data, si el problema persiste favor comunicarse con un administrador', errorToast());
        }
    }

    const loading = () => {
        dispatch({
          type: LOADING
        });
      }
      
    return ( 
        <VacationContext.Provider
            value={{
                loading: state.loading,
                vacation: state.vacation,
                getVacationByUser: getVacationByUser
            }}
        >
            {props.children}
        </VacationContext.Provider>
     );
}
 
export default VacationState;